export const getTextFromHTMLString = (htmlString) => {
    if (!htmlString) {
        return '';
    }
    // Make a copy of the string to avoid modifying the original
    return `${htmlString}`.replace(/<[^>]+>/g, '');
};
